import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CollapsibleCard from 'Components/ComponentLibrary/Components/Uncategorized/CollapsibleCard/CollapsibleCard';
import DataContainer from 'Components/UI/DataContainer';
import fr from 'facet-rest';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import HoldingsSectionContent from './Content';

const useStyles = buildUseStyles('HoldingsSection', () => ({
  root: {},
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

const Title = ({
  color,
  label,
  percentage,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <Box className={classes.title}>
      <Text color={color} variant={'h5'} weight={'medium'} text={label} />
      <Text color={color} variant={'h5'} weight={'medium'} text={`${percentage}%`} />
    </Box>
  );
};

Title.defaultProps = {
  color: 'primary',
};

Title.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string.isRequired,
  percentage: PropTypes.string.isRequired,
};

const HoldingsSection = ({
  className,
  color,
  holdingsTypeLabel,
  holdingsPercentage,
  holdingsRelationshipLink,
}) => {
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState(null);
  const [holdingsCollection, setHoldingsCollection] = useState(null);
  const theme = useTheme();
  const classes = useStyles(theme);

  const fetchRelationship = async () => {
    setLoading(true);
    try {
      const collection = await holdingsRelationshipLink.get();
      setHoldingsCollection(collection);
    } catch (e) {
      setErrors(e);
    }
    setLoading(false);
  };

  const onClick = async () => {
    if (holdingsCollection === null || errors !== null) {
      await fetchRelationship();
    }
  };

  useComponentDidMount(async () => {
    await fetchRelationship();
  });

  return (
    <CollapsibleCard
      title={<Title color={color} label={holdingsTypeLabel} percentage={holdingsPercentage} />}
      className={classNames(className, classes.card)}
      onClick={onClick}
    >
      {!errors && (
        <DataContainer
          component={HoldingsSectionContent}
          componentProps={{
            holdingsCollection,
            color,
          }}
          loading={loading}
        />
      )}
    </CollapsibleCard>
  );
};

HoldingsSection.defaultProps = {
  className: '',
  color: 'primary',
};

HoldingsSection.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  holdingsRelationshipLink: PropTypes.instanceOf(fr.Link).isRequired,
  holdingsTypeLabel: PropTypes.string.isRequired,
  holdingsPercentage: PropTypes.string.isRequired,
};

export default HoldingsSection;
